import { Inject, Injectable } from '@angular/core';
import { IUnitOfWork } from 'src/app/common/contracts/unit-of-work/unit-of-work';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { ServiceTaskDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ServiceTaskDto } from 'src/app/shared/models/serviceTask/service-task-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ServiceTaskWorkItem extends WorkItem<ServiceTaskDto> {
  unitOfWork: IUnitOfWork;

  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }

  get name(): string {
    return 'ServiceTaskWorkItem';
  }

  get database(): string {
    return ServiceTaskDB;
  }
}
